<div class="content__inner">
    <header class="content__title">
        <h1>{{ "stolencameras.list.title" | translate }}</h1>
        <small>{{ "stolencameras.list.subtitle" | translate }}</small>

        <div class="actions"></div>
    </header>

    <div class="card" *appHasPermission="'STOLENCAMERAS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "stolencameras.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="camowner">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.camowner" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.getCamOwnerDetails() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="camera">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.camera" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.getCameraDetails() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.city" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.city }}</td>
                    </ng-container>

                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.country" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.country }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "stolencameras.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="editStolenCamera(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'STOLENCAMERAS.EDIT'"></i>
                                <i (click)="deleteStolenCamera(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'STOLENCAMERAS.DELETE'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>
</div>
